import { PayloadAction } from '@reduxjs/toolkit';
import {
  ACTION_TYPE,
  Header,
  ITableData
} from 'src/pages/analytics/simulator/pricing-simulator/types/generic-table.model';
import getUpdatedDataForDropdown, {
  getUpdatedDataForPhRecommendation
} from '../../utils/boolean-calculations';
import getUpdatedData from '../../utils/numeric-calculations';

const getFunctionByType = (
  actionType: ACTION_TYPE,
  currrentRowData: any,
  columnMetadata: Header,
  newInputValue: string | number | boolean,
  tableMetaData: ITableData
) => {
  switch (actionType) {
    case ACTION_TYPE.DROPDOWN:
    case ACTION_TYPE.CHECKBOX:
      return getUpdatedDataForDropdown(
        currrentRowData,
        columnMetadata,
        newInputValue as boolean
      );

    case ACTION_TYPE.NUMBER:
      return getUpdatedData(
        currrentRowData,
        columnMetadata,
        tableMetaData,
        newInputValue as number
      );

    default:
      return null;
  }
};

// handler for getting updated for ph recommendation

export default function getDataForGlobalInputChange(
  tableMetaData: ITableData,
  actionType: ACTION_TYPE,
  action: PayloadAction<{
    columnMetadata: Header;
    newValue: number;
  }>
) {
  const { columnMetadata, newValue } = action.payload;
  const makeUpdatedDataLevel = (metaData): any =>
    metaData.map((data: any) => ({
      parent: {
        data: getFunctionByType(
          actionType,
          data,
          columnMetadata,
          newValue,
          tableMetaData
        )
      },
      children:
        data.children && data.children.length
          ? makeUpdatedDataLevel(data.children)
          : []
    }));
  return makeUpdatedDataLevel(tableMetaData.row);
}

// handler for getting updated data for ph follow/unfollow
export function getDataPhRecommendationInputChange(
  tableMetaData: ITableData,
  actionType: ACTION_TYPE,
  action: PayloadAction<{
    columnMetadata: Header;
    newValue: any;
  }>
) {
  const { columnMetadata, newValue } = action.payload;
  const makeUpdatedDataLevel = (metaData): any =>
    metaData.map((data: any) => ({
      parent: {
        data: getUpdatedDataForPhRecommendation(data, columnMetadata, newValue)
      },
      children:
        data.children && data.children.length
          ? makeUpdatedDataLevel(data.children)
          : []
    }));
  return makeUpdatedDataLevel(tableMetaData.row);
}
